export default {
  regularFees: 'regular_fees',
  slidingScale: 'sliding_scale',
};
